import { filters } from "./filters";
export default {
  saveParameterIsEnabled: true,
  visualizationMode: "card",
  production: [],
  demo: [],
  investment: [],
  selectedParameter: {},
  color: [
    "#FFFF99",
    "#336179",
    "#C14BD1",
    "#E47529",
    "#D7C94E",
    "#1F4D65",
    "#B336C5",
    "#D06115",
    "#2E7171",
    "#B9AB30",
    "#15435B",
    "#A422B6",
    "#BC4D14",
    "#D1D5DB",
    "#9CA3AF",
  ],
  masks: [
    "GAIN_LIMIT",
    "STOP_LOSS",
    "PARTIAL_GAIN",
    "LOSS_LIMIT",
    "TAKE_PROFIT",
    "TRADES_LIMIT",
    "TIME_LIMIT",
    "FIRST_PLAY",
    "BREAKEVEN",
    "REVERSAL",
    "EXTERNAL_ACTION",
    "REJECTED_ORDER",

    // -----
    "NEW_POSITION",
    "UPDATE_POSITION",
    "POSITION_CLOSE",
    "NEW_ORDER",
    "UPDATE_ORDER",
    "ORDER_CLOSE",
  ],
  parameters: {
    parameterSettings: [],
    selectedParameter: {},
    // ---------------------------------------------
    // relativo a tela de editar parâmetros
    info: {},
    copy_info: {},
    section_index: 0, //índice da seção visível
    // ---------------------------------------------
  },
  webSocket: null,
  topics: [],
  adjustments: {
    search: null,
    filters: [],
    order: {
      asc: true,
      desc: false,
      max_profit: false,
      min_profit: false,
      position_asc: false,
      position_desc: false,
    },
  },
  filters,
};
